import _ from 'lodash';

export class PaginationController {

	constructor($scope, $location, searchService) {
		this.searchService = searchService;
		this.location = $location;

		this.pager = this.searchService.getPager();
		this.initializeData();

		$scope.$watch( () => {
			return this.searchService.getPager();
		}, () => {
			this.pager = this.searchService.getPager();
			this.initializeData();
		});
	}

	initializeData() {
		this.showPagination = this.searchService.getResults().length > 0;
		this.pageBlock = this.pager.pageData();
		this.pageLast = this.pager.getLast();
		this.pageFirst = this.pager.getFirst();
	}

	goto(page) {
		if (page) {
			this.searchService.getFilter('page').setValue(page);
			var routeBuilder = this.searchService.getRouteBuilder();
			this.location.search(routeBuilder.getRoute());
			this.searchService.query();
		}
	}

	next() {
		this.goto(this.pager.nextPage());
	}

	prev() {
		this.goto(this.pager.prevPage());
	}

	isLastPageInBlock() {
		return _.find(this.pageBlock, { num: this.pageLast }) ? true : false;
	}

	isFirstPageInBlock() {
		return _.find(this.pageBlock, { num: this.pageFirst }) ? true : false;
	}



}

PaginationController.$inject = ['$scope', '$location', 'searchService'];